export enum UserRole {
  Admin = "ADMIN",
  ReportsFull = "REPORTS_FULL",
  ReportsBasic = "REPORTS_BASIC",
}
